import { createContext, Dispatch, SetStateAction } from "react";

export const LoginContext = createContext<{
  contractCode: string;
  setContractCode: Dispatch<SetStateAction<string>>;
  userCode: string;
  setUserCode: Dispatch<SetStateAction<string>>;
  password: string;
  setPassword: Dispatch<SetStateAction<string>>;
}>({
  contractCode: "",
  setContractCode: () => null,
  userCode: "",
  setUserCode: () => null,
  password: "",
  setPassword: () => null,
});
